import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { ConfirmPopupComponent } from '../components/confirm-popup/confirm-popup.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmPopupService {
  constructor(private dialog: MatDialog) {}

  openConfirmDialog(data: any): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      autoFocus: false,
      width: 'auto',
      panelClass: 'confirm-dialog-panel',
      backdropClass: 'confirm-dialog-backdrop',
      disableClose: true,
      data,
      maxWidth: '90vw',
      maxHeight: '90vh',
    });

    return dialogRef.afterClosed();
  }
}
